import { ObjectValues } from 'type-alias';

export const USER_STATUS = {
  System: 'System',
  Active: 'Active',
  Disabled: 'Disabled',
  NotDefined: 'NotDefined',
} as const;

export type USER_STATUS_VALUES = ObjectValues<typeof USER_STATUS>;
